import script from "./UserEngagement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEngagement.vue?vue&type=script&setup=true&lang=js"

import "./UserEngagement.vue?vue&type=style&index=0&id=5e5eff54&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5eff54"]])

export default __exports__